// removed by extract-text-webpack-plugin
module.exports = {"fadeInUp":"frontend__fadeInUp___2GPxR","fadeInDown":"frontend__fadeInDown___3LmXW"};


//////////////////
// WEBPACK FOOTER
// ./src/css/frontend.scss
// module id = 251
// module chunks = 4